import { defineAction } from 'redux-define';
import { HTTP_CODES } from './http.constants';

const START = 'START';
const DONE = 'DONE';
const ERROR = 'ERROR';
const SET = 'SET';
const RESET = 'RESET';
const SUCCESS = 'SUCCESS';
const ADD = 'ADD';
const UPDATE = 'UPDATE';

const spo = defineAction('spo');
const application = defineAction('application', [], spo);

export const API_ACTIONS = defineAction('API', Object.values(HTTP_CODES), application);
export const FETCH_ACTIONS = defineAction('FETCH', [START, DONE, ERROR, RESET], application);
export const AUTH_ACTIONS = defineAction('AUTH', [SUCCESS, RESET], application);
export const BREADCRUMBS_ACTIONS = defineAction('BREADCRUMBS', [SET, RESET], application);

export const RESOURCES_ACTIONS = defineAction('RESOURCES', [ADD, UPDATE, RESET], application);
